import { SearchProps } from '~components/form-fields/search';

import { isEncryptionEnabled } from '~libs/encryptionSettings';

/**
 * Search/filter fields for the Care Plans client list.
 *
 * Client name uses the standard `text-like` filter over first_name/surname — the
 * GET /clients/care-plans endpoint applies it server-side (before pagination) via the
 * Query lib's iLike mechanism, consistent with ClientsWithBudgets. Hidden when
 * encryption is enabled, since encrypted names can't be searched.
 */
export const searchFields: SearchProps = {
  client: {
    defaultShow: true,
    type: 'text-like',
    field: ['first_name', 'surname'],
    placeholder: 'Client Name',
    caption: 'Client',
    hidden: isEncryptionEnabled,
  },
  status: {
    defaultShow: true,
    type: 'lookup',
    field: 'status',
    caption: 'Status',
    placeholder: 'Select Status',
    options: [
      { id: '', name: 'All' },
      { id: 'active', name: 'Active' },
      { id: 'overdue', name: 'Overdue' },
      { id: 'expired', name: 'Expired' },
      { id: 'none', name: 'None active' },
    ],
  },
};

export default searchFields;
